import React, { useState } from 'react';
import { MDBIcon, MDBModal, MDBModalHeader, MDBModalBody } from 'mdbreact';

// Definição dos números do painel — todo painel tem uma. Fica atrás de um
// botão "Como ler" na barra de ações do cabeçalho (ao lado de "Atualizar") e abre num modal, para
// não pesar no fim da tela.
// itens: [{ icone, titulo, texto }] — `texto` aceita JSX. `icone` é nome do
// FontAwesome 4: é a fonte que desenha `fa fa-*` no SIG (shield-alt e
// user-shield, que são do FA5, saem como um retângulo vazio).
export default function NotaMetodologica({ titulo = 'Como ler estes números', itens = [] }) {
  const [aberta, setAberta] = useState(false);
  const alterna = () => setAberta((v) => !v);
  return (
    <>
      <button type="button" className="painel-acao" onClick={alterna} title={titulo} aria-haspopup="dialog">
        <MDBIcon icon="question-circle" />
        Como ler
      </button>
      <MDBModal isOpen={aberta} toggle={alterna} size="lg" centered>
        <MDBModalHeader toggle={alterna}>{titulo}</MDBModalHeader>
        <MDBModalBody>
          <dl className="painel-nota mb-0">
            {itens.map(({ icone, titulo: t, texto }) => (
              <div key={t} className="painel-nota__item">
                <MDBIcon icon={icone} fixed className="painel-nota__icone" />
                <div>
                  <dt>{t}</dt>
                  <dd>{texto}</dd>
                </div>
              </div>
            ))}
          </dl>
        </MDBModalBody>
      </MDBModal>
    </>
  );
}
